export const reformatUrlAndGetTargetValue = (url: string) => {
  let href = url;

  if (url) {
    const match = urlMatch(url);

    if (match && !["http", "https"].includes(match[2])) {
      // if there's a match and it doesn't include http or https, we need to prepend with http://,
      // otherwise the <a> tag assumes its a partial and will prepend with current hostname.
      href = "http://" + url;
    } else if (!match) {
      if (url.startsWith("/")) {
        href = url;
      } else {
        href = "/" + url;
      }
    }
  }

  const target = determineATagTargetValue(href);

  return { href, target };
};

const urlMatch = (url: string) => {
  // No match will be found for partial paths like `/product_listing?type=1`
  return url.match(
    /^((http|https):\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i,
  );
};

const determineATagTargetValue = (url: string) => {
  if (!url || url.includes("app.provi.com") || !urlMatch(url)) {
    return "_self";
  }
  // If the url is a partial path or for a provi link, we want the link to open in the same window.
  // Otherwise, we want the link to open in a new tab.

  return "_blank";
};
